import React from 'react';
import {
    UnprocessedOrderType,
    LogisticsTypeCode,
    LogisticsStatusCode,
    OrderStateTypes,
} from '../../types';

export type OrderStateChangeInfo = {
    type:
        | UnprocessedOrderType
        | 'prepDeliverySpecial'
        | 'reload'
        | 'forceReload'
        | 'customerServiceCompensate'
        | 'lossCompensateNew'
        | 'userCompensate'
        | 'updateFourWheelDelivery'; //新增四轮发配后的局部更新;
    orderViewId?: string;
    logisticsStatus?: LogisticsStatusCode;
    logisticsCode?: LogisticsTypeCode;
    // all：返回有所模块详情
    updateBlock?: 'all' | string;
    skipOrderCountUpdate?: boolean;
};

export type OrderListContextType = {
    listType: UnprocessedOrderType | 'history' | 'search' | 'unknown';
    historyOrderState?: OrderStateTypes;
    handleOrderStateChange: (changeInfo: OrderStateChangeInfo) => void;
    disableReload: () => void;
    enableReload: () => void;
};

const defaultData: OrderListContextType = {
    listType: 'unknown',
    historyOrderState: undefined,
    handleOrderStateChange: () => null,
    disableReload: () => {},
    enableReload: () => {},
};

const OrderListContext = React.createContext<OrderListContextType>(defaultData);

export default OrderListContext;
